import { ImplementDimensionsSubform } from "portal/views/equipment/implements/ImplementDimensionsSubform";
import { ImplementManeuveringSubform } from "portal/views/equipment/implements/ImplementManeuveringSubform";
import { ImplementViewModel } from "../ImplementViewModel";
import { TemplateOverride } from "../../TemplateOverride";
import { typedPath } from "typed-path";
import { useFormikContext } from "formik";
import React, { FC } from "react";

const S = typedPath<ImplementViewModel>();
export const AutonomyMeasurementsStep: FC<{ disabled?: boolean }> = ({
  disabled,
}) => {
  const formikProps = useFormikContext<ImplementViewModel>();

  return (
    <div className="flex flex-col gap-2">
      <TemplateOverride
        checked={formikProps.values.overrideAutonomyMeasurements}
        disabled={disabled}
        onChange={() => {
          formikProps.setFieldValue(
            S.overrideAutonomyMeasurements.$path,
            !formikProps.values.overrideAutonomyMeasurements
          );
        }}
      />
      <ImplementDimensionsSubform
        basePath={S}
        mode={
          formikProps.values.overrideAutonomyMeasurements && !disabled
            ? "edit"
            : "readonly"
        }
      />
      <ImplementManeuveringSubform
        basePath={S}
        values={formikProps.values}
        mode={
          formikProps.values.overrideAutonomyMeasurements && !disabled
            ? "edit"
            : "readonly"
        }
      />
    </div>
  );
};
